// eppo-proxy is a CDN in front of Eppo: a trace header forces a CORS preflight,
// and Cloud CDN never caches OPTIONS, so every preflight would hit Eppo.
const allowedTracingUrlsRegex = /https?:\/\/(?!refer\.|eppo-proxy\.)([a-zA-Z0-9-]+\.)*booksy\.(com|pm)/

export default allowedTracingUrlsRegex
